import { render, staticRenderFns } from "./BoxButtonLayout.vue?vue&type=template&id=5d83f58c&scoped=true"
import script from "./BoxButtonLayout.vue?vue&type=script&lang=js"
export * from "./BoxButtonLayout.vue?vue&type=script&lang=js"
import style0 from "./BoxButtonLayout.vue?vue&type=style&index=0&id=5d83f58c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d83f58c",
  null
  
)

export default component.exports